import { getGroupById } from 'api/operations/groupService';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { AssigneeType, ContactInfo, Group, GroupSource } from 'types/groupService';

export const INITIAL_GROUP_OBJECT: Group = Object.freeze({
  id: '',
  name: '',
  source: GroupSource.AGENT_V2,
  browsingCriteria: {
    effectiveDate: '',
    zipCode: '',
    state: '',
    county: '',
  },
  contactInfo: {
    firstName: '',
    lastName: '',
    primaryEmail: '',
    title: '',
    primaryPhone: '',
    primaryAddress: {
      city: '',
      street: '',
      street2: '',
      zip: '',
      state: '',
      county: '',
    },
  },
  creationDateTime: '',
  assigned: [],
  agentOfRecord: {
    id: '',
    name: '',
    npn: '',
    email: '',
    type: AssigneeType.AGENT,
  },
  accountRepresentative: null,
  lastUpdateTime: '',
  notes: '',
  archived: false,
  additionalAORs: [],
  additionalContactInfos: [],
  seUserRole: 'BROKER',
});

export default class GroupModule {
  private _group: Group = INITIAL_GROUP_OBJECT;
  private _isLoading: boolean = true;

  private _setIsLoading(isLoading: boolean): void {
    this._isLoading = isLoading;
  }

  public get isLoading(): boolean {
    return this._isLoading;
  }

  public get group(): Group {
    return this._group;
  }

  public get groupName(): string {
    return this._group.name;
  }

  public get groupContactInfo(): ContactInfo {
    return this._group.contactInfo;
  }

  public async getGroup(groupId: string): Promise<void> {
    this._setIsLoading(true);
    const group = await getGroupById(groupId);
    runInAction(() => {
      this._group = group;
      this._setIsLoading(false);
    });
  }

  constructor() {
    makeObservable<GroupModule, '_group' | '_isLoading' | '_setIsLoading'>(this, {
      _group: observable,
      _isLoading: observable,
      isLoading: computed,
      group: computed,
      groupName: computed,
      groupContactInfo: computed,
      getGroup: action.bound,
      _setIsLoading: action.bound,
    });
  }
}
